import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const WatchReportConnector = React.lazy(
  () => import('components/Tools/WatchReport/WatchReport'),
);

function ScreensToolsWatchReport() {
  return (
    <BaseLayout>
      <DocumentTitle>Watch Data Report</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <WatchReportConnector />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensToolsWatchReport;
